/* eslint-disable no-sequences */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Space } from "antd";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { productLineHead } from '../../../../../../config/constant';
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import { LineForm } from "./LineForm";
import { LineTable } from "./LineTable";
import { emptyValidation } from "../../../../../../helpers/validation";
import ExportIcon from "../../../../../../assets/images/icon_actions/Export.svg";
import dayjs from 'dayjs';
import moment from 'moment';
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";

export const LineView = React.forwardRef((props, ref) => {
    const { roleManagement, checkComponentPermission, clsx, idNamingConversion, classes, dispatch, productActions, productPrices, customObject, myProductdetails,
        unitMesurementdetails, handleProductPrice, currencyFormat, capitalizeFirstLetter, sortBy, sortOrder,
        handleSearch, form, headerView, lineSubmit, lines, allLines, exportCommonFile, productApi, onRequestSort, search } = props;
    const [iconAnimation, setIconAnimation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [lineForm, setLineForm] = useState({});
    const [every, setEvery] = useState({});

    const [lineError, setLineError] = useState({});
    const [title, setTitle] = useState('Add');
    const [lineId, setLineId] = useState('');
    const [view, setView] = useState(false);
    const [unitPriceFocusList, setUnitPriceFocusList] = useState(false);
    const [unitPriceList, setUnitPriceList] = useState(false);

    const everyAll = {
        every_1: false, every_2: false, every_3: false, every_4: false, every_5: false, every_6: false, every_7: false, every_8: false, every_9: false, every_10: false, every_11: false, every_12: false, every_13: false, every_14: false, every_15: false, every_16: false, every_17: false, every_18: false, every_19: false, every_20: false, every_21: false, every_22: false, every_23: false, every_24: false, every_25: false, every_26: false, every_27: false, every_28: false, every_29: false, every_30: false, every_31: false
    };

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        productApi();
        setView(false);
        setLineId('');
        setLineForm({
            batch_automate: true,
            useLatestPrice: true,
            status: true,
        });
        setLineError({});
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        exportCommonFile(name, allLines, data, selected, extension);
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, true);
    }


    const changeEveryHandler = (e) => {
        setEvery({
            ...every,
            [e.target.name]: e.target.checked
        });
    }

    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyProduct = emptyValidation('Product', lineForm?.productId, 'dropDown');
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyWorkflow = emptyValidation('WorkFlow', lineForm?.workflowId, 'dropDown');
        let emptyFrequency = emptyValidation('Frequency', lineForm?.scheduleFrequencyId, 'dropDown');
        let emptyQuantity = emptyValidation('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Amount', lineForm?.amount);
        let emptyStateDate = emptyValidation('Start Date', lineForm?.start_date);
        let ev = true;
        Object.filter = (obj, predicate) =>
            Object.keys(obj)
                .filter(key => predicate(obj[key]))
                .reduce((res, key) => (res[key] = obj[key], res), {});

        let cEvery = Object.filter(every, e => e);
        if (lineForm?.scheduleFrequency?.occurenceCount > 0) {
            if (Object.keys(cEvery).length === 0 || lineForm?.scheduleFrequency?.occurenceCount < Object.keys(cEvery).length) {
                ev = false
            }
        }

        setLineError({});
        if (emptyProduct.isValid && emptyUnit.isValid && emptyQuantity.isValid &&
            emptyWorkflow.isValid && emptyFrequency.isValid &&
            emptyAmount.isValid && ev && emptyStateDate.isValid) {
            lineForm.quantity = parseInt(lineForm.quantity);
            lineForm.amount = parseFloat(lineForm.amount);
            lineForm.customerId = form?.customerId;
            let a = { ...lineForm, ...everyAll, ...every };
            // delete a.product; delete a.scheduleFrequency; delete a.scheduleFrequency;
            // delete a.business; delete a.unit; delete a.workflow;
            // delete a.scheduling; delete a.customerProduct;
            if (a?.start_date) {
                a.start_date = moment(a?.start_date).format("YYYY-MM-DD")
            }
            if (a?.end_date) {
                a.end_date = moment(a?.end_date).format("YYYY-MM-DD")
            } else {
                a.end_date = null
            }
            //a.end_date = a?.end_date ? moment(a?.end_date).format("YYYY-MM-DDT00:00:00.000+00:00") : moment().format("YYYY-MM-DDT00:00:00.000+00:00");
            if (a?.schedule_time) {
                a.schedule_time = moment(a?.schedule_time).format("HH:mm");
            } else {
                a.schedule_time = "00:00";
            }
            a.status = a.status ? 'ACTIVE' : 'INACTIVE';
            lineSubmit(a, lineId);
            handleOpen();
            if (more) {
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else {
            setLineError({
                productId: emptyProduct?.errors || false,
                unitId: emptyUnit?.errors || false,
                quantity: emptyQuantity?.errors || false,
                amount: emptyAmount?.errors || false,
                workflowId: emptyWorkflow?.errors || false,
                scheduleFrequencyId: emptyFrequency?.errors || false,
                start_date: emptyStateDate?.errors || false,
                every: ev ? '' : Object.keys(cEvery).length === 0 ? 'Please Choose any one' : 'Cant select more than ' + lineForm?.scheduleFrequency?.occurenceCount
            })
        }
    }


    useEffect(() => {
        handleSetProductPrice(lineForm?.unitId);
    }, [productPrices]);

    const handleSetProductPrice = (lineUnitId = '') => {
        let data = {};
        if (productPrices && productPrices !== '') {
            if (productPrices?.priceagreement && Object.keys(productPrices?.priceagreement).length > 0 &&
                productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                let result = productPrices?.priceagreement[customObject(unitMesurementdetails, lineUnitId)?.name][0];
                data['amount'] = result?.price || '';
                setUnitPriceList(true);
            } else {
                if (productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 &&
                    productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name]) {
                    let result = productPrices?.lastprice[customObject(unitMesurementdetails, lineUnitId)?.name];
                    data['amount'] = result?.price || '';
                    setUnitPriceList(false);
                } else {
                    let d = customObject(myProductdetails, lineForm?.productId);
                    if (d) {
                        data['amount'] = d?.latestPurchasePrice || '';
                    }
                }
            }
        } else {
            let d = customObject(myProductdetails, lineForm?.productId);
            data['amount'] = d?.latestPurchasePrice || '';
        }
        setLineForm({
            ...lineForm,
            ...data,
        });
    }

    const shouldBlur = (e) => {
        setUnitPriceList(false);
        setUnitPriceFocusList(false);
    }

    const handleProductChange = (d) => {
        if (d?.id) {
            let data = {
                productId: d?.id,
                product: d
            }
            //data['description'] = d?.product?.productName;
            data['unitId'] = d?.salesUnitId || '';
            data['unit'] = d?.salesUnit || '';
            setLineForm({ ...lineForm, ...data });
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/saledprice/${form?.customerId}/${d?.id}/${lineForm?.quantity || 1}`
            });
        }
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'unit': e
                });
            } else if (name === 'scheduleFrequencyId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'scheduleFrequency': e
                });
                setEvery({});
            } else if (name === 'workflowId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'workflow': e
                });
            } else {
                setLineForm({
                    ...lineForm,
                    [name]: e
                });
            }

        } else {
            setLineForm({
                ...lineForm,
                [e.target.name]: e.target.value
            });
        }
    }

    const onEdit = (data, i, view) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        productApi('', data?.productId);
        let a = { ...data };
        a.start_date = a.start_date ? dayjs(a.start_date).$d : null;
        a.end_date = a.end_date ? dayjs(a.end_date).$d : null;
        a.schedule_time = a.schedule_time ? dayjs(moment().format('YYYY-MM-DDT' + a.schedule_time)).$d : null;
        a.amount = a?.amount || 0;
        setLineForm(a);
        let allowed = [];
        for (let i = 0; i <= 31; i++) {
            allowed.push(`every_${i}`);
        }
        setEvery(
            Object.keys(a)
                .filter(key => allowed.includes(key))
                .reduce((obj, key) => {
                    obj[key] = a[key];
                    return obj;
                }, {})
        );
    }

    return (
        <>
            <Row>
                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                    {
                        roleManagement !== '' && checkComponentPermission('Customer Product Scheduling', 'Page', 'Search Line') &&
                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                            <TextField autoComplete='one-time-code'
                                placeholder='Search'
                                type='search'
                                value={search}
                                onChange={(e) => handleSearch(e.target.value)}
                                className={classes.comInput}
                                variant={'standard'}
                                fullWidth
                                id={idNamingConversion('Search', 'customerProductSchedulingLine', 'TextField')}
                                onFocus={() => setIconAnimation(true)}
                                onBlur={() => setIconAnimation(false)}
                            />
                            <Image src={SearchIcon} preview={false} />
                            {
                                search && <NavLink to="#" onClick={() => handleSearch('')} className={classes.searchClear}>
                                    <Image
                                        src={ClearIcon}
                                        preview={false}
                                    />
                                </NavLink>
                            }
                        </div>
                    }
                </Col>
                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24}
                    className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                    <div className={classes.vertiCalScrollOverFlow}>
                        <Space size={[20, 20]} direction="horizontal" align="center">
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Product Scheduling', 'Page', 'Export') &&
                                <NavLink to={'#'} onClick={() => loadImportExportData('CustomerProductScheduling')} className={clsx(classes.customLink, classes.disInline)}>
                                    <Image
                                        src={ExportIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                </NavLink>
                            }
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Product Scheduling', 'Page', 'Add Lines') && <>
                                    {
                                        form?.customerId && !headerView &&
                                        <NavLink to={'#'} onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                            <Image
                                                src={AddIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Lines</span>
                                        </NavLink>
                                    }
                                </>
                            }
                        </Space>
                    </div>
                </Col>
            </Row>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    heads={productLineHead}
                    width={true}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                    component={
                        <LineTable
                            productLineHead={productLineHead}
                            {...props}
                            onEdit={(d, i, v) => onEdit(d, i, v)}
                        />
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'690px'}
                title={title + ' Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <LineForm
                        {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        every={every}
                        title={title}
                        view={view}
                        lineId={lineId !== '' ? lineId + 1 : lines.length + 1}
                        headerView={headerView}
                        handleAddMore={(e) => handleAddMore(e)}
                        lineError={lineError}
                        handleEdit={(v) => { setView(v); setTitle('Edit') }}
                        shouldBlur={(e) => shouldBlur(e)}
                        unitPriceFocusList={unitPriceFocusList}
                        unitPriceList={unitPriceList}
                        unitMesurementdetails={unitMesurementdetails}
                        priceFocusList={(v) => setUnitPriceFocusList(v)}
                        handleProductPrice={(key) => handleProductPrice(key)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        changeHandler={(e, name) => changeHandler(e, name)}
                        changeEveryHandler={(e) => changeEveryHandler(e)}
                        handleProductChange={(data) => handleProductChange(data)}
                        capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                        onEdit={(d, i, v) => onEdit(d, i, v)}
                    />
                }
            />
        </>
    )
})